import {Transition, type TransitionProps} from '@mantine/core';
import type React from 'react';
import {COLOR_AI_GRADIENT_START} from '../../../../config/constants/colorCodes';
import {cn} from '../../../../lib/classname';
import {CustomFollowCompanyButton} from './CustomFollowCompanyButton';

type Props = Omit<TransitionProps, 'children'> & {
  companyId: number;
  isFollowed: boolean;
  followCount: number;
  className?: string;
  buttonClassName?: string;
  onFollowChange?: (isFollowed: boolean, followCount: number) => void;
  customFollowText?: string;
};

export const TransitionFollowButton: React.FC<Props> = ({
  companyId,
  isFollowed,
  followCount,
  className,
  buttonClassName,
  onFollowChange,
  customFollowText = 'この企業をフォローする',
  ...transitionProps
}: Props) => {
  return (
    <Transition {...transitionProps}>
      {(styles) => (
        <div
          className={cn('fixed bottom-0 left-0 right-0', className)}
          style={{...styles, zIndex: 1000}}
        >
          <div
            className="flex justify-center flex-wrap py-8"
            style={{
              background: `${COLOR_AI_GRADIENT_START}`,
              opacity: 0.9,
            }}
          >
            <div className={cn(buttonClassName)}>
              <CustomFollowCompanyButton
                companyId={companyId}
                isFollowed={isFollowed}
                followCount={followCount}
                onFollowChange={onFollowChange}
                customFollowText={customFollowText}
              />
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};
